// extracted by mini-css-extract-plugin
module.exports =  {"main":"main__DZtuh","pageContainer":"pageContainer__3AaBM"};